<template>
  <el-aside width="220px" class="sidebar">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#333"
      text-color="#fff"
      active-text-color="#ffd04b"
      :default-active="activeMenuItem"
    >
      <el-menu-item index="/directory" @click="handleMenuClick('/directory')" v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles])">
        <span>Справочник ДО</span>
      </el-menu-item>
      <el-menu-item index="/timesheet/list" @click="handleMenuClick('/timesheet')" v-if="hasAccess([...adminRoles, ...managerRoles])">
        <span>Загруженные табели</span>
      </el-menu-item>
      <el-menu-item index="/report" @click="handleMenuClick('/report')" v-if="hasAccess([])">
        <span>Отчеты</span>
      </el-menu-item>
      <el-menu-item index="/kindergarten/heads" @click="handleMenuClick('/kindergarten/heads')" v-if="hasAccess([...managerRoles, ...adminRoles])">
        <span>Директора ДО</span>
      </el-menu-item>
      <el-menu-item index="/kindergarten/retention" @click="handleMenuClick('/kindergarten/retention')" v-if="hasAccess([...managerRoles, ...adminRoles])">Авансирование/удержание</el-menu-item>
      <el-menu-item index="/report/to/sign" @click="handleMenuClick('/report/to/sign')" v-if="hasAccess([...managerRoles, ...adminRoles])">Отчеты на подписание</el-menu-item>
      <el-menu-item index="/acts/reconciliation" @click="handleMenuClick('/acts/reconciliation')" v-if="hasAccess([...managerRoles, ...adminRoles])">
        <span>Сверка актов</span>
      </el-menu-item>
      <el-menu-item index="/acts/acceptance" @click="handleMenuClick('/acts/acceptance')" v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles])">
        <span>Принятие актов</span>
      </el-menu-item>
      <el-menu-item index="/invoice/reconciliation" @click="handleMenuClick('/invoice/reconciliation')" v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles, ...kindergarteHeadRoles])">
        <span>Работа с ЭСФ</span>
      </el-menu-item>
      <el-menu-item index="/kindergarten/fact/payment" @click="handleMenuClick('/kindergarten/fact/payment')" v-if="hasAccess([...accountantRoles, ...adminRoles])">
        <span>Фактическая оплата</span>
      </el-menu-item>
      <el-menu-item index="/report-sign" @click="handleMenuClick('/report-sign')" v-if="hasAccess(kindergartenHeadRoles)">Отчеты на подписание {{ documentCountForSign }}</el-menu-item>
      <el-menu-item index="/report/1c" @click="handleMenuClick('/report/1c')" v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles])">Отчет на 1C</el-menu-item>
      <el-menu-item index="/report/forMIO" @click="handleMenuClick('/report/forMIO')" v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles])">Отчет для МИО</el-menu-item>
      <el-menu-item index="/kindergarten/act/reconciliation" @click="handleMenuClick('/kindergarten/act/reconciliation')" v-if="hasAccess([...kindergartenHeadRoles])">Сверка Акт</el-menu-item>
      <el-menu-item index="/kindergarten/act/reconciliation/status" @click="handleMenuClick('/kindergarten/act/reconciliation/status')" v-if="hasAccess([...adminRoles, ...accountantRoles])">Загруженные акты</el-menu-item>
      <el-menu-item index="/admin/notifications" @click="handleMenuClick('/admin/notifications')" v-if="hasAccess([...adminRoles, ...managerSpkRoles, ...managerRoles])">Уведомление</el-menu-item>
      <el-menu-item index="/admin/audit" @click="handleMenuClick('/admin/audit')" v-if="hasAccess([...adminRoles])">Журнал аудита</el-menu-item>
      <el-menu-item index="/admin/lms-log" @click="handleMenuClick('/admin/lms-log')" v-if="hasAccess([...adminRoles])">Обращения LMS</el-menu-item>
      <el-menu-item index="/client/notifications" @click="handleMenuClick('/client/notifications')" v-if="hasAccess([...kindergartenHeadRoles])">Уведомление</el-menu-item>
      <el-menu-item index="/children" @click="handleMenuClick('/children')" v-if="hasAccess([...adminRoles, ... managerRoles])">Дети ДО</el-menu-item>
      <el-menu-item index="/children/duplicates" @click="handleMenuClick('/children/duplicates')" v-if="hasAccess([...adminRoles, ...managerRoles])">Дубли контингента</el-menu-item>
      <el-menu-item index="/kindergarten-analytics" @click="handleMenuClick('/kindergarten/analytics')" v-if="hasAccess([...adminRoles, ... managerRoles])">Статусы по ДО </el-menu-item>
      <el-menu-item index="/kindergarten-1c-act-reconciliation" @click="handleMenuClick('/kindergarten-1c-act-reconciliation')" v-if="hasAccess([...kindergartenHeadRoles, ...findirRoles, ...accountantRoles])">Акты сверок 1С </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import authService from "@/services/authService";

export default defineComponent({
  name: "MenuComponent",
  setup() {
    const activeMenuItem = ref("/directory");
    const router = useRouter();

    const adminRoles: string[] = authService.getAdminRoles();
    const managerRoles: string[] = authService.getManagerRoles();
    const kindergartenHeadRoles: string[] = authService.getKindergartenHeadRoles();
    const accountantRoles: string[] = authService.getAccountantRoles();
    const kindergarteHeadRoles: string[] = authService.getKindergartenHeadRoles();
    const managerSpkRoles: string[] = authService.getManagerSpkRoles();
    const findirRoles: string[] = authService.getFinDirRoles();
    const documentCountForSign = 0;

    const handleMenuClick = (path: string) => {
      activeMenuItem.value = path;
      router.push(path);
    };
    const hasAccess = authService.hasAccess;

    return {
      activeMenuItem,
      handleMenuClick,
      adminRoles,
      managerRoles,
      kindergartenHeadRoles,
      accountantRoles,
      kindergarteHeadRoles,
      managerSpkRoles,
      findirRoles,
      hasAccess,
      documentCountForSign,
    };
  },
});
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background-color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 20px;
}

.el-menu-vertical-demo {
  width: 100%;
  border-right: none;
  margin-top: 60px;
}
</style>
